import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'https://eval-comportementale-api.bessacvps.fr'

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(async (config) => {
  const token = await (window as any).Clerk?.session?.getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      ;(window as any).Clerk?.signOut()
      window.location.href = '/sign-in'
    }
    return Promise.reject(error)
  }
)
